// src/components/ProductModal.js
import React from 'react';
import { Modal, Button, Row, Col, Descriptions } from 'antd';
import '../assets/scss/ProductModal.scss';

const ProductModal = ({ show, onHide, product }) => {
    const handleClose = () => {
        onHide();
    };

    return (
        <Modal
            open={show}
            onCancel={handleClose}
            footer={[
                <Button key="close" onClick={handleClose}>Close</Button>
            ]}
            title="Product Details"
            width={900}
            className="modal-header"
        >
            <Row gutter={[24, 24]} wrap align="top">
                <Col xs={24} md={7} lg={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <img
                        src={product.cover_img}
                        alt={product.item_title}
                        style={{ width: '100%', maxWidth: 220, borderRadius: 10, boxShadow: '0 2px 12px #e0e0e0', marginBottom: 16, objectFit: 'contain', background: '#fff' }}
                    />
                </Col>
                <Col xs={24} md={17} lg={18} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 }}>
                            <span style={{ fontSize: 22, fontWeight: 700 }}>{product.item_title}</span>
                            <span style={{ fontSize: 18, fontWeight: 600, color: '#389e0d' }}>
                                {product.unit_price?.toLocaleString('en-US', { style: 'currency', currency: 'LKR' })}
                            </span>
                        </div>
                        <Descriptions
                            size="small"
                            column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
                            bordered
                            style={{ marginBottom: 16 }}
                        >
                            <Descriptions.Item label="ID">{product.item_id}</Descriptions.Item>
                            <Descriptions.Item label="ISBN">{product.isbn || '-'}</Descriptions.Item>
                            <Descriptions.Item label="EAN13">{product.ean13 || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Authors">{product.authors || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Publisher">{product.mtanufacture || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Last print">{product.last_print || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Category">{product.category || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Department">{product.department || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Weight">{product.weight ? `${product.weight} g` : '-'}</Descriptions.Item>
                            <Descriptions.Item label="Pack size">{product.pack_size || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Is group Item">{product.is_group === 1 ? 'Yes' : 'No'}</Descriptions.Item>
                            <Descriptions.Item label="Language">{product.language_text || '-'}</Descriptions.Item>
                            <Descriptions.Item label="Edition">{product.edition || '-'}</Descriptions.Item>
                        </Descriptions>
                        {product.branch_info && (
                            <Descriptions
                                size="small"
                                column={{ xs: 1, sm: 2, md: 4, lg: 4, xl: 4 }}
                                bordered
                                style={{ marginBottom: 12, background: '#fafafa' }}
                            >
                                <Descriptions.Item label="Re-Level"><b>{product.branch_info.reorder_level || '-'}</b></Descriptions.Item>
                                <Descriptions.Item label="Re-Qty"><b>{product.branch_info.reorder_qty || '-'}</b></Descriptions.Item>
                                <Descriptions.Item label="Rack No"><b>{product.branch_info.rack_no || '-'}</b></Descriptions.Item>
                                <Descriptions.Item label="Rack No2"><b>{product.branch_info.rack_no2 || '-'}</b></Descriptions.Item>
                            </Descriptions>
                        )}
                        {product.branches?.length > 0 && (
                            <div style={{ marginTop: 8 }}>
                                <h5 style={{ marginBottom: 8 }}>Branch Availability</h5>
                                <Row gutter={[8, 8]}>
                                    {product.branches.map((branch, index) => (
                                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                            <div style={{ 
                                                border: '1px solid #f0f0f0', 
                                                borderRadius: 6, 
                                                padding: 8, 
                                                background: '#fafafa', 
                                                textAlign: 'center' 
                                            }}>
                                                <b>{branch.branch || 'N/A'}:</b>{' '}
                                                <span style={{ 
                                                    color: branch.qty > 0 ? '#389e0d' : '#cf1322' 
                                                }}>
                                                    {branch.qty > 0 ? 'Available' : 'Out of Stock'}
                                                </span>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </Modal>
    );
};

export default ProductModal;